import BaseService from "@/attributes/BaseService";
import { PageType } from "../const";
import PageModel from "../datamodel/PageModel";
class PageService extends BaseService {
  async createPageInFile(propertyKey: string, pageModel: PageModel) {
    await this.saveToDB({
      _id: `base-data-${pageModel.id}`,
      value: { page: pageModel, permissions: pageModel.permissions }
    });
  }
  async updatePageInFile(pageId: string, pageModel: PageModel) {
    this.getFromDB(`base-data-${pageId}`).then((res: any) => {
      console.log("updatePageInFile1", res?.value);
      const { page, permissions } = res?.value || {};
      const newData = {
        page: {
          ...page,
          ...pageModel
        },
        permissions
      };

      this.saveToDB({
        _id: `base-data-${pageModel.id}`,
        // @ts-ignore
        value: newData
      });
    });
  }
  async setParentFolder(folderInfo: any, pageId: string) {
    setTimeout(async () => {
      await this.saveToDB({ _id: `folderInfo-${pageId}`, value: [folderInfo] });
    }, 400);
  }
  setListExist(list: any[]): any {
    // console.log(list, "setListExist222");
    return new Promise((resolve, reject) => {
      const p: Array<Promise<any>> = [];
      list.forEach((item: any) => {
        const pageType = item.page_type || item.pageType;
        // console.log("setListExist444", item.id, pageType);
        // 判断离线列表中协同表格和协同文档是否缓存
        if (pageType === PageType.Sheet || pageType === PageType.Page) {
          p.push(
            this.getFromDB(`base-data-${item.id}`).then((doc: any) => {
              //   console.log("setListExist333", item.id, doc);
              if (doc) {
                item.isDBExist = true;
                item.isExist = true;
              }
            })
          );
        }
      });
      Promise.all(p)
        .then((res: any) => {
          //   console.log(list, "setListExist111");
          resolve(list);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  }
  concatList2Page(list: any[]): any {
    return new Promise((resolve, reject) => {
      const result: Array<PageModel> = [];
      const p: Array<Promise<any>> = [];
      list.forEach((id: any) => {
        p.push(
          this.getFromDB(`base-data-${id}`).then((doc: any) => {
            const _isNew = doc.page_id ? doc.isNew : true;
            doc && result.push({ ...doc.value.page, id, isNew: _isNew, isExist: true });
          })
        );
      });
      Promise.all(p)
        .then((res: any) => {
          result.sort((a: PageModel, b: PageModel) => b.updated_at - a.updated_at);
          resolve(result);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  }
  async remove(id: string) {
    try {
      this.deleteFromDB(`base-data-${id}`);
      this.deleteFromDB(`folderInfo-${id}`);
      return true;
    } catch (error) {
      return false;
    }
  }
}
// new PageService('joyspace.db', 'apis');
export default PageService;
